


















import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import DefaultFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/DefaultFieldsetHandler.vue'
import ContactInfoFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/ContactInfoFieldsetHandler.vue'
import CategoryFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/CategoryFieldsetHandler.vue'
import PhotosFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/PhotosFieldsetHandler.vue'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import VehicleDetailsFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/VehicleDetailsFieldsetHandler.vue'
import LeasingFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/LeasingFieldsetHandler.vue'
import Footer from '~/components/car/classifieds/form/footer/Footer.vue'
import OfferInfoFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/OfferInfoFieldsetHandler.vue'
import TradesFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/TradesFieldsetHandler.vue'
import DescriptionFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/DescriptionFieldsetHandler.vue'

export default Vue.extend({
  components: {
    Footer,
    ContactInfoFieldsetHandler,
    CategoryFieldsetHandler,
    PhotosFieldsetHandler
  },
  computed: {
    ...mapState(CLASSIFIED_FORM_NS, {
      fieldsets: state => state.fieldsets || [],
      pageKey: state => state.pageKey,
      invalidTriggered: state => state.invalidTriggered
    }),
    ...mapGetters(CLASSIFIED_FORM_NS, {
      onlyDealersAllowedGuard: 'onlyDealersAllowedGuard'
    }),
    fieldsetsToShow() {
      if (this.onlyDealersAllowedGuard) {
        return this.fieldsets.filter(f => f.name === 'category')
      }
      return this.fieldsets
    }
  },
  methods: {
    getFieldsetComponent(name: string) {
      // loads a custom fieldset handler based on fieldset name
      switch (name) {
        case 'contact_info': {
          return ContactInfoFieldsetHandler
        }
        case 'category': {
          return CategoryFieldsetHandler
        }
        case 'photos': {
          return PhotosFieldsetHandler
        }
        case 'vehicle_details': {
          return VehicleDetailsFieldsetHandler
        }
        case 'leasing': {
          return LeasingFieldsetHandler
        }
        case 'offer_info': {
          return OfferInfoFieldsetHandler
        }
        case 'trades': {
          return TradesFieldsetHandler
        }
        case 'description': {
          return DescriptionFieldsetHandler
        }
        default: {
          return DefaultFieldsetHandler
        }
      }
    }
  }
})
